import { gql } from '@apollo/client'

export const confirmUserCourseOrder = gql`
  mutation ConfirmUserCourseOrder(
    $userId: String!
    $courseId: String!
    $order: String!
    $coupon: String
  ) {
    confirmUserCourseOrder(userId: $userId, courseId: $courseId, order: $order, coupon: $coupon)
  }
`
